import { render, staticRenderFns } from "./ParentingTime.vue?vue&type=template&id=faa46b0a&scoped=true"
import script from "./ParentingTime.vue?vue&type=script&lang=js"
export * from "./ParentingTime.vue?vue&type=script&lang=js"
import style0 from "./ParentingTime.vue?vue&type=style&index=0&id=faa46b0a&prod&lang=css"
import style1 from "./ParentingTime.vue?vue&type=style&index=1&id=faa46b0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faa46b0a",
  null
  
)

export default component.exports